<form class="create-form" [formGroup]="form">
  <app-form>
    <app-row>
      <p-fileUpload
        mode="basic"
        chooseLabel="Выбрать файл"
        chooseIcon="pi pi-upload"
        accept=".jrxml"
        [class.loading]="loading"
        [maxFileSize]="maxFileSize"
        (onSelect)="onSelect($event)"
      />
    </app-row>

    <app-row>
      <app-field [label]="'name' | caption: tableName">
        <input type="text" pInputText formControlName="name" [class.loading]="loading" />
      </app-field>
    </app-row>

    <app-row>
      <app-field [label]="'description' | caption: tableName">
        <input type="text" pInputText formControlName="description" [class.loading]="loading" />
      </app-field>
    </app-row>
  </app-form>
</form>
